enum FilterContainer {
  TopSecretHotelContainer = 'TopSecretHotelContainer',
  FreeCancellationContainer = 'FreeCancellationContainer',
  BookNowPayLaterContainer = 'BookNowPayLaterContainer',
  FlashSalesContainer = 'FlashSalesContainer',
  PriceContainer = 'PriceContainer',
  FlightContainer = 'FlightContainer',
  PropertyTypeContainer = 'PropertyTypeContainer',
  PropertyNameContainer = 'PropertyNameContainer',
  LeisureContainer = 'LeisureContainer',
  StarsContainer = 'StarsContainer',
  MealContainer = 'MealContainer',
  RatingContainer = 'RatingContainer',
  FacilitiesContainer = 'FacilitiesContainer',
  SortContainer = 'SortContainer',
  BeachTypeContainer = 'BeachTypeContainer',
  ClimateContainer = 'ClimateContainer',
  DestinationAirportContainer = 'DestinationAirportContainer',
  OvernightFlightsContainer = 'OvernightFlightsContainer',
  EntertainmentsContainer = 'EntertainmentsContainer',
  FaunaContainer = 'FaunaContainer',
  WatersportContainer = 'WatersportContainer',
  WaterwavesContainer = 'WaterwavesContainer',
  BlueFlagContainer = 'BlueFlagContainer',
  SustainabilityCertificateContainer = 'SustainabilityCertificateContainer',
  DiscountsContainer = 'DiscountsContainer',
  AccommodationDistrictsContainer = 'AccommodationDistrictsContainer',
  AccommodationBeachContainer = 'AccommodationBeachContainer',
  AccommodationSkiliftContainer = 'AccommodationSkiliftContainer',
  AccommodationStationsContainer = 'AccommodationStationsContainer',
  AccommodationChainsContainer = 'AccommodationChainsContainer',
  AirlinesContainer = 'AirlinesContainer',
  AccommodationThemesContainer = 'AccommodationThemesContainer',
  directContainer = 'DirectContainer',
  OutboundArrivalAirportsContainer = 'OutboundArrivalAirportsContainer',
  OutboundDepartureAirportsContainer = 'OutboundDepartureAirportsContainer',
  OutboundConnectionsContainer = 'OutboundConnectionsContainer',
  ReturnConnectionsContainer = 'ReturnConnectionsContainer',
  ReturnArrivalAirportsContainer = 'ReturnArrivalAirportsContainer',
  ReturnDepartureAirportsContainer = 'ReturnDepartureAirportsContainer',
  SameOutboundAirportContainer = 'SameOutboundAirportContainer',
  SameReturnAirportContainer = 'SameReturnAirportContainer',
  sameAirportContainer = 'SameAirportContainer',
  AirportsContainer = 'AirportsContainer',
  OutboundContainer = 'OutboundContainer',
  ReturnContainer = 'ReturnContainer',
  DepartureTimeContainer = 'DepartureTimeContainer',
  StopsContainer = 'StopsContainer',
  BookingOptionsContainer = 'BookingOptionsContainer',
  AllFiltersContainer = 'AllFiltersContainer',
  SustainabilityContainer = 'SustainabilityContainer',
  PinkPeopleContainer = 'PinkPeopleContainer',
}

export default FilterContainer;
